import { createContext, useContext } from "react";
import { useLocation } from "react-router-dom";

export const ClientContext = createContext();

export const ClientProvider = ({ children }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const client = searchParams.get("client");

  return (
    <ClientContext.Provider value={client}>
      {children}
    </ClientContext.Provider>
  );
};

export const useClient = () => {
  return useContext(ClientContext);
};
